import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport'
import { AnswerID } from '@aytm/app/swidget/base/questions/types'
import { IEcommerceQuestionSchema } from '../../types.ts'
import ProductCard from './ProductCard.tsx'
import useCarouselNav from './useCarouselNav.ts'
import style from './SponsoredCarousel.module.scss'

interface ISponsoredCarouselProps {
  schema: IEcommerceQuestionSchema
  amountById: Map<AnswerID, number>
  findability: boolean
  onItemSelect: (id: AnswerID) => void
  onAddToCart: (id: AnswerID, qnt: number) => void
}

const SponsoredCarousel = ({ schema, amountById, findability, onItemSelect, onAddToCart }: ISponsoredCarouselProps) => {
  const viewport = useViewport()
  const { t } = useSurveyLocale()
  const featured = schema.answers.filter(answer => answer.featured && !answer.na && !answer.parent_product)
  const { trackRef, nav, measureNav, slide } = useCarouselNav(featured.length)

  return featured.length > 0 ? (
    <section className={`${style.section} ${viewport.mobile ? style.sectionMobile : ''}`}>
      <h2 className={style.heading}>{t('questions', 'ec', 'kroger', 'youMayAlsoLike')}</h2>
      <div className={style.viewport}>
        {nav.overflowing && (
          <>
            {!viewport.mobile && (
              <button
                type="button"
                className={`${style.navBtn} ${style.navBtnLeft}`}
                disabled={nav.atStart}
                onClick={() => slide(-1)}
                aria-label={t('questions', 'ec', 'kroger', 'previous')}
              >
                <i className="pi pi-chevron-left" />
              </button>
            )}
            <span className={`${style.fade} ${style.fadeLeft} ${nav.atStart ? '' : style.fadeVisible}`} />
            <span className={`${style.fade} ${style.fadeRight} ${nav.atEnd ? '' : style.fadeVisible}`} />
            {!viewport.mobile && (
              <button
                type="button"
                className={`${style.navBtn} ${style.navBtnRight}`}
                disabled={nav.atEnd}
                onClick={() => slide(1)}
                aria-label={t('questions', 'ec', 'kroger', 'next')}
              >
                <i className="pi pi-chevron-right" />
              </button>
            )}
          </>
        )}
        <div ref={trackRef} className={style.track} onScroll={measureNav}>
          {featured.map(answer => (
            <div key={answer.id} className={style.slide}>
              <ProductCard
                data-testid="SW-EC-CarouselItem"
                schema={schema}
                answer={answer}
                amount={amountById.get(answer.id) ?? 0}
                findability={findability}
                compact
                saveToList={false}
                disabled={'focus' == schema.mode_type && !answer.focused}
                onSelect={() => onItemSelect(answer.id)}
                onAdd={qnt => onAddToCart(answer.id, qnt)}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  ) : null
}

export default SponsoredCarousel
